/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuditLogResponse } from '../models/AuditLogResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AuditLogService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Search Audit Logs
   * audit log를 검색합니다.
   * @param slug
   * @param userIds 사용자 ID로 필터링
   * @param actions 액션으로 필터링
   * @param startDate 시작 날짜 (YYYY-MM-DD)
   * @param endDate 종료 날짜 (YYYY-MM-DD)
   * @param page 페이지 번호 (1부터 시작)
   * @param pageSize 페이지당 항목 수
   * @returns AuditLogResponse Successful Response
   * @throws ApiError
   */
  public searchAuditLogsV1WorkspacesSlugAuditLogsGet(
    slug: string,
    userIds?: Array<number> | null,
    actions?: Array<string> | null,
    startDate?: string | null,
    endDate?: string | null,
    page: number = 1,
    pageSize: number = 20
  ): CancelablePromise<AuditLogResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspaces/{slug}/audit-logs',
      path: {
        slug: slug,
      },
      query: {
        user_ids: userIds,
        actions: actions,
        start_date: startDate,
        end_date: endDate,
        page: page,
        page_size: pageSize,
      },
      errors: {
        401: `인증되지 않은 요청`,
        403: `권한 부족`,
        422: `Validation Error`,
      },
    });
  }

  /**
   * Export Audit Logs
   * audit log를 CSV로 내보냅니다.
   * @param slug
   * @param userIds 사용자 ID로 필터링
   * @param actions 액션으로 필터링
   * @param startDate 시작 날짜 (YYYY-MM-DD)
   * @param endDate 종료 날짜 (YYYY-MM-DD)
   * @returns any Successful Response
   * @throws ApiError
   */
  public exportAuditLogsV1WorkspacesSlugAuditLogsExportGet(
    slug: string,
    userIds?: Array<number> | null,
    actions?: Array<string> | null,
    startDate?: string | null,
    endDate?: string | null
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspaces/{slug}/audit-logs/export',
      path: {
        slug: slug,
      },
      query: {
        user_ids: userIds,
        actions: actions,
        start_date: startDate,
        end_date: endDate,
      },
      errors: {
        401: `인증되지 않은 요청`,
        403: `권한 부족`,
        422: `Validation Error`,
      },
    });
  }
}
